<template>
	<nav class="order-nav margin-b-100" v-if="showStepper">

		<ul v-if="productType === 'App\\Product'">
			<li>
                <router-link active-class="active" :to="{name:'make-order.order.summary'}" v-if="!isStepperLocked">Ordre</router-link>
                <a class="disabled" href="#" @click.prevent="" v-else>Ordre</a>
            </li>
			<li>
				<router-link active-class="active" :to="{name:'make-order.order.information'}" v-if="completedSummary && !isStepperLocked">Oplysninger</router-link>
				<a class="disabled" href="#" @click.prevent="" v-else>Oplysninger</a>
			</li>
			<li>
				<router-link active-class="active" :to="{name:'make-order.order.delivery'}" v-if="completedInformation && !isStepperLocked">Levering</router-link>
				<a class="disabled" href="#" @click.prevent="" v-else>Levering</a>
			</li>
			<li>
				<router-link active-class="active" :to="{name:'make-order.order.approve'}" v-if="completedDelivery">Betal</router-link>
				<a class="active" href="#" @click.prevent="" v-else-if="completedDelivery && isStepperLocked">Betal</a>
				<a class="disabled" href="#" @click.prevent="" v-else>Betal</a>
			</li>
		</ul>

        <ul v-if="productType === 'App\\CustomProduct'">
            <li>
                <router-link active-class="active" :to="{name:'make-order.custom.order.summary'}" v-if="!isStepperLocked">Ordre</router-link>
                <a class="disabled" href="#" @click.prevent="" v-else>Ordre</a>
            </li>
            <li>
                <router-link active-class="active" :to="{name:'make-order.custom.order.information'}" v-if="completedSummary && !isStepperLocked">Oplysninger</router-link>
                <a class="disabled" href="#" @click.prevent="" v-else>Oplysninger</a>
            </li>
            <li>
                <router-link active-class="active" :to="{name:'make-order.custom.order.delivery'}" v-if="completedInformation && !isStepperLocked">Levering</router-link>
                <a class="disabled" href="#" @click.prevent="" v-else>Levering</a>
            </li>
            <li>
                <router-link active-class="active" :to="{name:'make-order.custom.order.approve'}" v-if="completedDelivery">Betal</router-link>
                <a class="active" href="#" @click.prevent="" v-else-if="completedDelivery && isStepperLocked">Betal</a>
                <a class="disabled" href="#" @click.prevent="" v-else>Betal</a>
            </li>
        </ul>

	</nav>
</template>

<script>
	import {mapGetters} from 'vuex';
    export default {
        name: "stepper",
		computed:{
            ...mapGetters({
                completedProduct: 'completedProduct',
                completedSummary:'completedSummary',
                completedInformation:'completedInformation',
                completedDelivery:'completedDelivery',
                isStepperLocked:'isStepperLocked',
                productType:'productType',
		    }),
            showStepper(){
                return this.$route.name !== 'order.complete' &&
                    this.$route.name !== 'order.failed' &&
                    this.$route.name !== 'order.card.failed' &&
                    this.$route.name !== 'custom.order.complete' &&
                    this.$route.name !== 'custom.order.failed' &&
                    this.$route.name !== 'custom.order.card.failed';
            }
        }
    }
</script>

<style scoped>

</style>
